<template>
	<div class="footer">
		<div style="background-color:#383d61" class="footer--bg"></div>
		<div class="footer--inner">
			<div class="am-g">
				<div class="am-u-md-3 ">
<!--					<div class="footer_main&#45;&#45;column">
						<strong class="footer_main&#45;&#45;column_title">产品中心</strong>
						<ul class="footer_navigation">
							<li class="footer_navigation&#45;&#45;item"><router-link to="/product" class="footer_navigation&#45;&#45;link">信息化建设</router-link></li>
							<li class="footer_navigation&#45;&#45;item"><router-link to="/product" class="footer_navigation&#45;&#45;link">可视化数据大屏</router-link></li>
							<li class="footer_navigation&#45;&#45;item"><router-link to="/product" class="footer_navigation&#45;&#45;link">平安园区</router-link></li>
						</ul>
					</div>-->
				</div>
				<div class="am-u-md-6 ">
					<div class="footer_main--column">
						<strong class="footer_main--column_title">关于我们</strong>
						<div class="footer_about">
							<p class="footer_about--text">
								峦璞(LuanPu Inc.) 是一家将尖端科技与传统拆迁行业深度融合的创新企业。我们专注于化工厂、电厂等大型废弃厂区的整体收购、智能化拆迁与有色金属资源回收，致力于通过技术革新推动行业升级，为客户创造可持续价值。
							</p>
						</div>
					</div>
				</div>
				<div class="am-u-md-3 ">
					<div class="footer_main--column">
						<strong class="footer_main--column_title">联系详情</strong>
						<ul class="footer_contact_info">
							<li class="footer_contact_info--item"><i class="am-icon-phone"></i><span>联系电话：13188883791</span></li>
							<li class="footer_contact_info--item"><i class="am-icon-envelope"></i><span>企业邮箱：lp@luanpu.com</span></li>
							<li class="footer_contact_info--item"><i class="am-icon-map-marker"></i><span>山东省菏泽市定陶区兴华路与站前路交叉口东300米路北</span></li>
							<li class="footer_contact_info--item"><i class="am-icon-clock-o"></i><span>周一 ~ 周日, 9:30 - 23:00 </span></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Footer"
}
</script>

<style scoped>

</style>
